import React, {useEffect, useMemo, useState, useRef} from "react";
import {inject, observer} from "mobx-react";
import SearchPreferencesHeader from "./components/SearchPreferencesHeader";
import MultipleSelect from "components/selects/MultipleSelect";
import {availableInArray} from "constants/select.consts";
import {useTranslation} from "react-i18next";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {useNavigate, useLocation} from "react-router-dom";
import {SAVE_SEARCH_SERVICE_CATEGORIES} from "constants/routes.const";
import {showError} from "helpers/notifications.helper";
import {regionsSchema} from "components/SearchPrefereces/formAttrs";
import {Header} from "components/Header/Header";

const SearchPreferencesRegions = inject("store")(
  observer(({store: {organization, auth}}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const renavigated = location.state?.renavigated;
    const [selectedRegions, setSelectedRegions] = useState([]);
    const {activeOrganizationId} = auth;
    const hasInitialized = useRef(false);

    const isAvailableIn = useMemo(() => {
      return auth?.user?.ActiveOrganization?.SearchPreference?.availableIn?.length > 0;
      // eslint-disable-next-line
      }, [auth, renavigated, auth?.user?.ActiveOrganization?.SearchPreference?.availableIn]);

    useEffect(() => {
      if (!hasInitialized.current) {
        hasInitialized.current = true;
        auth.checkToken(true).then(() => {
          const initSelectedRegions =
            auth?.user?.ActiveOrganization?.SearchPreference?.availableIn || [];
          if (isAvailableIn || initSelectedRegions.length)
            setSelectedRegions(initSelectedRegions);
        });
      }
    }, [auth, isAvailableIn, renavigated]);

    const handleContinue = async () => {
      try {
        await regionsSchema.validate({availableIn: selectedRegions});

        organization
          .saveSearchRegions(selectedRegions)
          .then(() => {
            return organization
              .setOrganizationOnboardingStatus(activeOrganizationId, {
                onboardingSettings: {
                  isAvailableIn: true,
                  isServiceCategories: false,
                },
              })
              .then(() => navigate(SAVE_SEARCH_SERVICE_CATEGORIES));
          })
          .catch(() => {
            showError(t("ERROR_SAVING_REGIONS"));
          });
      } catch (error) {
        showError(t(error.message));
      }
    };

    return (
      <div className="search-regions-page">
        <Header addClass="settings-page__header" type="language" />
        <SearchPreferencesHeader />
        <div className="search-regions-content">
          <h2 className="search-regions-title">{t("SEARCH_REGIONS_TO_SERVE_LABEL")}</h2>
          <p className="search-regions-description">{t("SELECT_ACTIVE_REGIONS")}</p>

          <div className="search-regions-selector">
            <MultipleSelect
              list={availableInArray}
              customSelectAllElement="FIRST_SETUP_REGION_00"
              value={selectedRegions}
              onChange={(value) => {
                setSelectedRegions(value);
              }}
            />
          </div>
        </div>
        <div className="search-regions-footer">
          <div className="search-regions-next">
            <span className={`next-text ${!selectedRegions.length ? "disabled" : ""}`}>
              {t("NEXT")}: {t("STEP_TEXT_SERVICES")}
            </span>
            <ButtonTransparent
              name={t("FIRST_SETUP_CONTINUE")}
              addClass={`search-regions-continue ${
                selectedRegions.length ? "__active" : ""
              }`}
              disabled={!selectedRegions.length}
              onClick={handleContinue}
            />
          </div>
        </div>
      </div>
    );
  })
);

export default SearchPreferencesRegions;
